import TrackingECommerce from './TrackingECommerce';

export default TrackingECommerce;
